import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const unpublish = {
  fetchUnpiblishComments: lazyModuleMethod(
    () => import('./fetchUnpiblishComments'),
    'default'
  ),
  fetchUnpiblishTopics: lazyModuleMethod(
    () => import('./fetchUnpiblishTopics'),
    'default'
  ),
  fetchUnpiblishProfiles: lazyModuleMethod(
    () => import('./fetchUnpiblishProfiles'),
    'default'
  ),
}
